module.exports = "/images/checkbox-inactive-selected.svg?53b1718d13454ac74227d9add6eda04f";